/* global Vimeo */

/* eslint space-before-function-paren: 0 */
/* eslint no-undef: 0 */
class IframeClickToPlay {
  /**
   * Create new iframe click to play instance
   * @param {Object} options Options
   * @param {HTMLElement} options.iframe Target iframe
   * @param {HTMLElement} options.fallback Fallback content
   * @param {HTMLButtonElement} options.trigger Click-to-play trigger
   */
  constructor({ iframe, fallback, trigger }) {
    this.container = iframe
    this.iframe = iframe
    this.src = iframe.dataset.src
    this.fallback = fallback
    this.trigger = trigger
    this.placeholder = document.createComment('')

    if (iframe.tagName !== 'IFRAME') {
      const descendant = iframe.querySelector('iframe')
      this.iframe = descendant
      this.src = descendant.dataset.src
    }
  }

  init() {
    if (!Cookiebot.consent.statistics || !Cookiebot.consent.marketing) {
      // Remove the iframe from the DOM to avoid a history entry on src change.
      this.container.after(this.placeholder)
      this.container.remove()
      this.fallback.style.display = 'grid'

      this.trigger.addEventListener('click', () => {
        this.play()
        this.setCookieConsent()
      })
    } else {
      this.play()
    }
  }

  setCookieConsent() {
    Cookiebot.submitCustomConsent(Cookiebot.consent.preferences, true, true)
    setTimestamps()
  }

  play() {
    // Set the iframe src before re-inserting the node into the DOM.
    // This avoids a history entry due to a src change.
    // this.iframe.src = this.src
    this.placeholder.replaceWith(this.container)

    this.fallback.remove()
    this.trigger.remove()
  }
}

const containers = document.querySelectorAll('.vimeo')

containers.forEach(container => {
  const iframe = container.querySelector('.js-vimeo-iframe-container')
  const fallback = container.querySelector('.js-vimeo-fallback')
  const trigger = container.querySelector('.js-vimeo-trigger')

  new IframeClickToPlay({ iframe, fallback, trigger }).init()
})

/**
 * Set Vimeo player time
 * @param {Object} player Vimeo player object
 * @param {number} time Time in seconds to jump to
 */
function setTime(player, time) {
  if (typeof time !== 'number') {
    return
  }

  player.setCurrentTime(time)
    // Silently fail
    .catch(() => { })
}

function setTimestamps() {
  const iframe = document.querySelector('.js-vimeo-player')
  const timestamps = document.querySelectorAll('.js-vimeo-timestamp')

  if (iframe) {
    const player = new Vimeo.Player(iframe)

    player.setColor('#00ab97')
      // Silently fail
      .catch(() => { })

    timestamps.forEach(timestamp => {
      const time = parseInt(timestamp.dataset.time)

      timestamp.addEventListener('click', () => {
        setTime(player, time)
      })
    })
  }
}

window.addEventListener('CookiebotOnLoad', function (e) {
  if (Cookiebot.consent.statistics && Cookiebot.consent.marketing) {
    setTimestamps()
  }
}, false)
